import { SVGProps } from './types';

const SortIcon = (props: SVGProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3333 2.66675V13.3334M11.3333 13.3334L8.66667 10.6667M11.3333 13.3334L14 10.6667M4.66667 13.3334V2.66675M4.66667 2.66675L2 5.33341M4.66667 2.66675L7.33333 5.33341"
        stroke="#57524D"
        stroke-width="1.16667"
        stroke-linecap="square"
      />
    </svg>
  );
};

export { SortIcon };
